var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event"},[_c('div',{staticClass:"event-time"},[_vm._v(_vm._s(_vm.event.start.format('HH:mm'))+" -\n"+_vm._s(_vm.event.end.format('HH:mm')))])])}
var staticRenderFns = []

export { render, staticRenderFns }